import { useMemo } from "react";

export type PillColor = 'green' | 'light_green' | 'red' | 'blue' | 'grey' | 'yellow' | 'orange' | 'purple';

type Props = {
  text: string,
  color?: PillColor,
  customColor?: {
    backgroundColor?: string;
    borderColor?: string;
    textColor?: string;
  }
};

function Pill({ text, color = 'blue', customColor }: Props ) {

  const colorCode = useMemo(() => {
    switch (color) {
      case 'green':
        return 'bg-lime-100 border-lime-200 border text-green-800';
      case 'light_green':
        return 'bg-emerald-50 border-emerald-200 border text-emerald-700';
      case 'blue':
          return 'bg-blue-100 border-blue-200 border text-blue-800';
      case 'red':
          return 'bg-red-100 border-red-200 border text-red-800';
      case 'yellow':
          return 'bg-yellow-100 border-yellow-200 border text-yellow-800';
      case 'orange':
          return 'bg-orange-100 border-orange-200 border text-orange-800';
      case 'purple':
          return 'bg-purple-100 border-purple-200 border text-purple-800';
      default:
        return 'bg-darker-gold-200';
    }
  }, [color])

  const customStyle = customColor ? {
    backgroundColor: customColor.backgroundColor,
    borderColor: customColor.borderColor,
    color: customColor.textColor,
  } : {};

  return (
    <span 
    className={
      `p-1 px-3 leading-5 font-semibold rounded-full max-h-7 text-xs lowercase whitespace-nowrap border ${colorCode}`
    }
    style={customStyle}
    >
      {text}
    </span>
  );
}

export default Pill;
